module.exports = __webpack_public_path__ + "static/media/LeagueLogo.28b192fc.svg";